"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class SalesLabel extends _react.default.Component {
  validate() {
    const {
      startSale,
      agentData: {
        agent = false,
        groupCode = false
      },
      loggedInData: {
        email
      }
    } = this.props;
    if (email && agent && agent === 'WY992' || groupCode && groupCode === 'MN') return startSale();
    return false;
  }
  render() {
    const {
      saleStarted,
      labelText,
      showOveride
    } = this.props;
    if (!showOveride && !saleStarted && !this.validate()) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "salesContainer"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label label-default sales-label"
    }, labelText));
  }
}
SalesLabel.propTypes = {
  labelText: _propTypes.string,
  startSale: _propTypes.func,
  saleStarted: _propTypes.bool,
  showOveride: _propTypes.bool,
  agentData: _propTypes.object,
  loggedInData: _propTypes.object
};
SalesLabel.defaultProps = {
  labelText: 'Sale',
  showOveride: false,
  saleStarted: false,
  startSale: () => {},
  agentData: {
    agent: false,
    groupCode: false
  },
  loggedInData: {
    email: false
  }
};
var _default = exports.default = SalesLabel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/salesLabel.js
// module id = 756
// module chunks = 119